import { render } from "./AccessGate.vue?vue&type=template&id=46546ec3"
import script from "./AccessGate.vue?vue&type=script&lang=js"
export * from "./AccessGate.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__